/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { IconConfig, IconResourceType } from './icon.model';

export const fontawesomeIconConfig: IconConfig = {
  icon: {
    symbols: {
      ACTIVE: 'fas fa-check',
      ADDRESS_BOOK: 'far fa-address-book',
      AMEX: 'fab fa-cc-amex',
      CARET_DOWN: 'fas fa-angle-down',
      CARET_LEFT: 'fas fa-angle-left',
      CARET_RIGHT: 'fas fa-angle-right',
      CARET_UP: 'fas fa-angle-up',
      CART: 'fas fa-shopping-cart',
      CART_PLUS: 'fas fa-cart-plus',
      CART_ARROW_DOWN: 'fas fa-cart-arrow-down',
      CHECK: 'fas fa-check',
      CIRCLE: 'fas fa-circle',
      CLIPBOARD_LIST: 'fas fa-clipboard-list',
      CLOCK: 'far fa-clock',
      CLOSE: 'fas fa-times',
      COLLAPSE: 'fas fa-minus',
      CREDIT_CARD: 'fas fa-credit-card',
      DINERS_CLUB: 'fab fa-cc-diners-club',
      DOWNLOAD: 'fas fa-download',
      EMPTY_HEART: 'far fa-heart',
      ERROR: 'fas fa-exclamation-circle',
      EXPAND_ARROWS: 'fas fa-expand',
      EXPAND: 'fas fa-plus',
      EYE_SLASH: 'fas fa-eye-slash',
      EYE: 'fas fa-eye',
      FILE: 'fas fa-file',
      FILTER: 'fas fa-filter',
      GRID: 'fas fa-th-large',
      HEART: 'fas fa-heart',
      INFO: 'fas fa-info-circle',
      LINK_OUT: 'fas fa-external-link-alt',
      LIST: 'fas fa-bars',
      MASTER_CARD: 'fab fa-cc-mastercard',
      OFF: 'fas fa-toggle-off',
      ON: 'fas fa-toggle-on',
      ORDER: 'fas fa-clipboard-list',
      PDF_FILE: 'fas fa-file-pdf',
      PENCIL: 'fas fa-pencil-alt',
      REPEAT: 'fas fa-retweet',
      RESET: 'fas fa-times-circle',
      SEARCH: 'fas fa-search',
      SORT_AMOUNT_DOWN: 'fas fa-sort-amount-down',
      SORT_AMOUNT_UP: 'fas fa-sort-amount-up',
      SORT_DOWN: 'fas fa-sort-down',
      SORT: 'fas fa-sort',
      STAR: 'fas fa-star',
      SUCCESS: 'fas fa-check-circle',
      TRASH: 'fas fa-trash',
      USER_FRIENDS: 'fas fa-user-friends',
      VISA: 'fab fa-cc-visa',
      WARNING: 'fas fa-exclamation-triangle',
      HEADSET: 'fas fa-headset',
      ATTACHMENT: 'fas fa-paperclip',
      UPLOAD: 'fas fa-upload',
      USER: 'fas fa-user',
      USER_PLUS: 'fas fa-user-plus',
      ARROW_LEFT: 'fas fa-arrow-left',
      ARROW_RIGHT: 'fas  fa-arrow-right',
      ARROW_DOWN: 'fas  fa-arrow-down',
      ARROW_UP: 'fas  fa-arrow-up',
    },
    resources: [
      {
        type: IconResourceType.LINK,
        url: '',
      },
    ],
  },
};
